import { Component, inject, Input } from '@angular/core';

import { CarouselItems } from 'app/modules/browse/models/carousel-items.enum';
import { Playlist } from '@kinomap-dev/ng-ui-lib/lib/models/playlist.model';
import { VideoPosterCardComponent } from '../../cards/video-poster-card/video-poster-card.component';
import { AsyncPipe, NgClass } from '@angular/common';
import { HorizontalScrollerComponent } from '../../horizontal-scroller/horizontal-scroller.component';
import {
  GpsOnly,
  ScenicCardComponent,
  VideoSection,
  Workout,
  Coaching,
  BrowseTypesEnum,
  PlaylistCardComponent,
} from '@kinomap-dev/ng-ui-lib';
import { browseTypeToPath } from 'app/modules/browse/helpers/browseTypeToPath.helpers';
import { Router, RouterLink } from '@angular/router';
import { FavoriteApi } from 'app/modules/browse/api/favorite.api';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ResponsiveService } from 'app/services/responsive.service';
import { selectProfileData } from 'app/store/me/me.selectors';
import { Store } from '@ngrx/store';
import { User } from 'app/models';
import { configureConnectionModal } from 'app/helpers/modal-helpers';
import { ModalService } from 'app/services/modal.service';
import { SwarmLoginService } from 'app/services';

@Component({
  selector: 'app-browse-carousel',
  templateUrl: './browse-carousel.component.html',
  styleUrls: ['./browse-carousel.component.scss'],
  standalone: true,
  imports: [
    HorizontalScrollerComponent,
    NgClass,
    PlaylistCardComponent,
    VideoPosterCardComponent,
    ScenicCardComponent,
    AsyncPipe,
    RouterLink,
  ],
})
export class BrowseCarouselComponent {
  @Input() itemType: CarouselItems = CarouselItems.Video;
  @Input() videos: VideoSection[] = [];
  @Input() gpsTracks: GpsOnly[] = [];
  @Input() workouts: Workout[] = [];
  @Input() coachings: Coaching[] = [];
  @Input() playlists: Playlist[] = [];

  private router: Router = inject(Router);
  private favoriteService: FavoriteApi = inject(FavoriteApi);
  private responsiveService: ResponsiveService = inject(ResponsiveService);
  private store: Store = inject(Store);
  private modalService: ModalService = inject(ModalService);
  private loginService: SwarmLoginService = inject(SwarmLoginService);

  subscriptions: Subscription[] = [];
  CarouselItem: typeof CarouselItems = CarouselItems;
  BrowseTypes: typeof BrowseTypesEnum = BrowseTypesEnum;
  user: Observable<User> = this.store.select(selectProfileData);
  selectedVideo: VideoSection | null = null;
  smallScreen$: BehaviorSubject<boolean> = this.responsiveService.smallScreen$;
  xSmallScreen$: BehaviorSubject<boolean> =
    this.responsiveService.xSmallScreen$;

  redirect(id: number, to: 'author' | 'browse'): Promise<boolean> {
    switch (to) {
      case 'author': {
        return this.router.navigate(['/dashboard/profile', id]);
      }
      case 'browse': {
        return this.router.navigate([browseTypeToPath(this.itemType), id]);
      }
    }
  }

  onSelectOrUnselectVideo(videoId?: number): void {
    const video: VideoSection = this.videos.find(
      (v: VideoSection) => v.id === videoId
    );
    if (!video) {
      this.selectedVideo = null;
      return;
    }
    this.selectedVideo = video;
  }

  onLikeClick(
    item: VideoSection | Coaching | Workout | GpsOnly | Playlist,
    type: BrowseTypesEnum
  ): void {
    if (!item) {
      return;
    }

    this.subscriptions.push(
      this.user.subscribe((user: User) => {
        if (!user) {
          this.modalService.reset();
          this.modalService.setClassName('connection-modal');
          configureConnectionModal(this.modalService, this.loginService);
          this.modalService.display();
          return;
        }

        if (item.is_favorite) {
          this.subscriptions.push(
            this.favoriteService
              .deleteFavorite$(item.id, type)
              .subscribe(() => (item.is_favorite = false))
          );
          return;
        }

        this.subscriptions.push(
          this.favoriteService
            .postFavorite$(item.id, type)
            .subscribe(() => (item.is_favorite = true))
        );

        item.is_favorite = !item.is_favorite;
      })
    );
  }
}
